// extracted by mini-css-extract-plugin
export var closeButton = "styles-module--closeButton--e3669";
export var closeButtonContainer = "styles-module--closeButtonContainer--9a7db";